module.exports = __webpack_public_path__ + "img/首页2-6-hover.a42fc83f.svg";